import React from 'react';
import { Box, CircularProgress, CircularProgressProps } from '@mui/material';

interface Props {
  color?: CircularProgressProps['color'];
}

function Loading({ color }: Props): JSX.Element {
  return (
    <Box
      display="flex"
      width="100%"
      marginTop="150px"
      data-testid="loading-indicator"
    >
      <Box m="auto">
        <CircularProgress color={color ?? 'primary'} />
      </Box>
    </Box>
  );
}

export { Loading };
